<template>
  <b-modal class="test-modal" v-model="show" hide-footer hide-header centered style="height: 100%; width: 100%"
           no-close-on-backdrop no-close-on-esc>
    <b-row style="height: 100%">
      <b-col md="8" id="viewer" style="height: 100%; padding-left: 0px; padding-right: 0px">
        <iframe :src="currentPdf" name="print_frame" id="print_frame" style="width: 100%; height: 100%; border: none; border-top-left-radius: 4px; border-bottom-left-radius: 4px"></iframe>
      </b-col>
      <b-col  style="height: 100%; padding-left: 0px">
        <h3 class="text-center" style="margin-top: 12px; margin-bottom: 12px"><b>Auftragsabrechnung</b></h3>
        <b-table style="border-top-right-radius: 4px;
    margin-bottom: 0px; height: calc(100% - 350px); max-height: calc(100% - 350px);" striped hover selectable :items="data" :fields="dataFields"
                 select-mode="range"
                 selectedVariant="primary"
                 @row-selected="rowSelected"
                 ref="task_table"
                 sticky-header
        >
          <template v-slot:cell(icon)="row">
            <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
            <check-icon class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:green" v-if="row.item.finished"></check-icon>
          </template>
        </b-table>
        <h5 style="margin-top: 12px; margin-left: 12px">Abrechnungsart</h5>
        <b-form-group
            style="margin-left: 12px; margin-right: 12px; margin-bottom: 0px"
            label="Rechnungsdarstellung"
        >
          <b-form-select
              v-if="showEinzel"
              :options="einzelSelects"
              v-model="enzelSelect"
              style="color: black !important;"
              size="sm">
          </b-form-select>
          <b-form-select
              v-else
              :options="sammelSelects"
              v-model="sammelSelect"
              style="color: black !important;"
              size="sm">
          </b-form-select>
          <b-row class="mt-2" v-if="definition">
            <b-col md="6" class="my-auto">
              <span>Schnittstellendateien herunterladen ?</span>
            </b-col>
            <b-col class="my-auto">
              <b-form-checkbox switch v-model="downloadApiFiles" ></b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="mt-2" v-if="definition && downloadApiFiles">
            <b-col md="6" class="my-auto">
              <span>Schnittstellendateien kombinieren ?</span>
            </b-col>
            <b-col class="my-auto">
              <b-form-checkbox switch v-model="combineInvoiceApiFiles" ></b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="6" class="my-auto">
              <span>Als ZUGFeRD Rechnung versenden ?</span>
            </b-col>
            <b-col class="my-auto">
              <b-form-checkbox switch v-model="isZugferd" ></b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col md="6" class="my-auto">
              <span>Als X-Rechnung versenden ?</span>
            </b-col>
            <b-col class="my-auto">
              <b-form-checkbox switch v-model="isXRechnung"></b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col >
              <b-button variant="success" pill class="mb-2" style="height: 35px; margin-top: 20px; width: 100%" :disabled="disabled" @click="modality = 'send'; generate()">
                <send-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></send-icon>Versenden
              </b-button>
            </b-col>
            <b-col >
              <b-button variant="success" pill class="mb-2" style="height: 35px; margin-top: 20px; width: 100%" :disabled="disabled" @click="modality = 'print'; generate()">
                <print-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></print-icon>Drucken
              </b-button>
            </b-col>
            <b-col >
              <b-button variant="success" pill class="mb-2" style="height: 35px; margin-top: 20px; width: 100%" :disabled="disabled" @click="modality = 'save'; generate()">
                <download-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></download-icon>Speichern
              </b-button>
            </b-col>
            <b-col >
              <b-button variant="primary" pill class="mb-2" style="height: 35px; margin-top: 20px; width: 100%" @click="close">
                <check-icon fillColor="white" class="icon-1_5x custom-icon" :size="72" style="color:white; margin-right: 16px;margin-left: -20px;"></check-icon>Fertig
              </b-button>
            </b-col>
          </b-row>

        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>


import {Server_URL} from "@/shared/utils";
import pdf from 'vue-pdf'
import EurIcon from 'vue-material-design-icons/CurrencyEur.vue';
import DownloadIcon from 'vue-material-design-icons/Download.vue';
import SendIcon from 'vue-material-design-icons/Send.vue';
import PrintIcon from 'vue-material-design-icons/CloudPrint.vue';
import CheckIcon from 'vue-material-design-icons/Check.vue';

export default {
  name: "calculation_overlay",
  components: {
    pdf,
    EurIcon,
    DownloadIcon,
    SendIcon,
    PrintIcon,
    CheckIcon
  },

  data() {
    return {
      show: false,
      data: [],
      selected: [],
      currentPdf: 'Bitte Auswaehlen.pdf',
      sammelSelect: 'sammel_details',
      sammelSelects: [
        {value: 'sammel_summen', text: 'ra_Interne Verrechnung - Summen'},
        {value: 'sammel_details', text: 'ra_Interne Verrechnung - Details'},
      ],
      enzelSelect: 'einzel',
      einzelSelects: [
        {value: 'einzel', text: 'ra_Rechnung'},
      ],
      isZugferd: false,
      isXRechnung: false,
      firstRequest: false,
      currentNumber: 1,
      rnrPrefix: '10-2025',
      modality: 'send',
      isKonto: false,
      currentIndex: -1,
      currentPreview: null,
      combineInvoiceApiFiles: true,
      definition: null,
      downloadApiFiles: false,
    }
  },
  props:{
    showLoader: {
      type: Function,
      default: undefined
    },
    hideLoader: {
      type: Function,
      default: undefined
    },
  },
  computed: {
    dataFields() {
      if (!this.isKonto) {
        return [
          {key: 'icon', label: '', thStyle: {width: '40px'}},
          {
            key: 'name', label: 'Auftrag', formatter: (value, key, item) => {
              return item.data.object + " - " + item.data.auf_name
            }
          },
          {
            key: 'price_sum', tdClass: 'text-right', label: 'Gesamtpreis', formatter: (value, key, item) => {
              let a = item.data.price_sum.toFixed(2) + ' €';
              return a.replace(".", ",");
            }
          },
        ]
      } else {
        return [
          { key: 'icon', label: '', thStyle: { width: '40px' } },
          { key: 'aus', label: 'Ausgabekonto', formatter: (value, key, item) => {
              return item.data.hh_aus_txt;
            }
          },
          { key: 'ein', label: 'Einnahmekonto', formatter: (value, key, item) => {
              return item.data.hh_ein_txt;
            }
          },
          { key: 'price_sum', tdClass: 'text-right', label: 'Gesamtpreis', formatter: (value, key, item) => {
              let a = item.data.price_sum.toFixed(2) + ' €';
              return a.replace(".", ",");
            }},
        ]
      }
    },
    showEinzel() {
      return this.selected.length === 1 && (this.selected[0].task.art_auf === "S" || this.selected[0].task.art === "D");
    },
    padded() {
      let num = this.currentNumber.toString();
      while (num.length < 4) num = "0" + num;
      return num;
    },
    defaultYear() {
      return LuxonDateTime.fromISO(this.currentMonth).year;
    },
    disabled() {
      for (let i = 0; i < this.selected.length; i++) {
        if (!this.selected[i].finished) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
    sammelSelect: function(newVal, oldVal) {
      if (this.firstRequest && this.selected.length) {
        this.showPreview(true);
      }
    },
    enzelSelect: function(newVal, oldVal) {
      if (this.firstRequest && this.selected.length) {
        this.showPreview(true);
      }
    },
  },
  methods: {
    close() {
      if (this.combineInvoiceApiFiles) {
        this.generateApiFile(null, true);
      } else {
        this.$emit('close');
        this.show = false
      }
    },
    generateApiFile(rnr, close) {
      if (!this.definition || !this.downloadApiFiles) {
        if (close) {
          this.$emit('close');
          this.show = false
        }
        return
      }
      let req = {
        definition_id: this.definition.id,
        invoice_numbers: []
      }
      if (rnr) {
        req.invoice_numbers = [rnr]
      } else {
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].rnr && this.data[i].rnr !== 'Vorschau') {
            req.invoice_numbers.push(this.data[i].rnr)
          }
        }
      }
      if (!req.invoice_numbers.length) {
        if (close) {
          this.$emit('close');
          this.show = false
        }
        return
      }
      this.$http.post(
          Server_URL+'/auftragsbuch/calculation/generate_invoice_api',
          req
      ).then((response) => {
        let filename = 'downloaded_file.txt';
        const disposition = response.headers.get('Content-Disposition');
        if (disposition && disposition.indexOf('filename=') !== -1) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
          if (matches != null && matches[1]) {
            // Remove potential surrounding quotes from the filename
            filename = matches[1].replace(/['"]/g, '');
          }
        }

        // 3. Create a blob URL from the response body
        const blob = new Blob([response.body]);
        const downloadUrl = window.URL.createObjectURL(blob);

        // 4. Create a hidden link and click it to trigger the download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', filename); // Set the filename

        // Append to body, click, and clean up
        document.body.appendChild(link);
        link.click();

        // 5. Cleanup the DOM and release the object URL memory
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        if (close) {
          this.$emit('close');
          this.show = false
        }
      }, (response) => {
        if (close) {
          this.$emit('close');
          this.show = false
        }
      });
    },
    showDialog(data, isKonto, definition) {
      this.firstRequest = false;
      this.selected = [];
      this.data = data;
      this.pdfs = {};
      this.currentPdf = 'Bitte Auswaehlen.pdf';
      this.show = true;
      this.isKonto = isKonto;
      this.definition = definition;
      this.currentPreview = null;

      this.$nextTick(() => {
        this.$refs.task_table.selectRow(0);
      });

    },
    rowSelected(items) {
      this.selected = items;
      if (items.length === 0) {
        this.currentPdf = 'Bitte Auswaehlen.pdf';
        return;
      }
      this.showPreview();
    },
    showPreview(force = false) {
      let item = this.selected[0];
      if (item.data.id === this.currentPreview && !force) {
        return
      }
      console.log(item)
      this.currentPreview = item.data.id;
      this.showLoader();
      let rnr = item.rnr;
      let req = {};
      if (!this.isKonto) {
        let task = item.task;
        let positions = item.data.positions;
        let taskEntries = [];
        let startDate = null;
        let endDate = null;
        for (let i = 0; i < positions.length; i++) {
          taskEntries.push(positions[i].id);
          if (startDate === null) {
            startDate = positions[i].dat_leist;
          } else {
            if (positions[i].dat_leist < startDate) {
              startDate = positions[i].dat_leist;
            }
          }
          if (endDate === null) {
            endDate = positions[i].dat_leist;
          } else {
            if (positions[i].dat_leist > endDate) {
              endDate = positions[i].dat_leist;
            }
          }
        }
        let templateNames = [];
        if (task.art_auf === "S" || task.art === "D") {
          templateNames.push(this.enzelSelect);
        } else {
          templateNames.push(this.sammelSelect);
        }
        req = {
          "data": {
            "invoiceNumber": item.rnr,
            "intakeAccount": task.hh_ein,
            "outtakeAccount": task.hh_aus,
            "billingPeriodStart": startDate,
            "billingPeriodEnd": endDate,
            "invoiceDate": new Date().toISOString(),
            "tasks": [
              {
                "id": task.id,
                "taskEntries": taskEntries
              }
            ]
          },
          "resultFileType": "Pdf",
          "templateNames": templateNames,
          "customerNumber": this.$cookies.get("ps_customer_number"),
          "aesKey": sessionStorage.getItem("aes")
        }
      } else {
        let positions = item.data.positions;
        let task = item.task;
        let aufMap = item.data.auf_map;
        let tasks = [];
        for (const [key, value] of Object.entries(aufMap)) {
          tasks.push({
            "id": key,
            "taskEntries": value
          });
        }
        let templateNames = [];
        if (task.art_auf === "S" || task.art === "D") {
          templateNames.push(this.enzelSelect);
        } else {
          templateNames.push(this.sammelSelect);
        }
        let startDate = null;
        let endDate = null;
        for (let i = 0; i < positions.length; i++) {
          if (startDate === null) {
            startDate = positions[i].dat_leist;
          } else {
            if (positions[i].dat_leist < startDate) {
              startDate = positions[i].dat_leist;
            }
          }
          if (endDate === null) {
            endDate = positions[i].dat_leist;
          } else {
            if (positions[i].dat_leist > endDate) {
              endDate = positions[i].dat_leist;
            }
          }
        }
        req = {
          "data": {
            "invoiceNumber": item.rnr,
            "intakeAccount": item.data.hh_ein,
            "outtakeAccount": item.data.hh_aus,
            "billingPeriodStart": startDate,
            "billingPeriodEnd": endDate,
            "invoiceDate": new Date().toISOString(),
            "tasks": tasks,
          },
          "resultFileType": "Pdf",
          "templateNames": templateNames,
          "customerNumber": this.$cookies.get("ps_customer_number"),
          "aesKey": sessionStorage.getItem("aes")
        }
      }

      this.$http.post(
          Server_URL+'/auftragsbuch/calculation/preview?rnr=' + (item.finished ? rnr : ""),
          req
      ).then((response) => {
        this.hideLoader();
        this.firstRequest = true;
        if (response.status === 200 ) {
          const byteCharacters = atob(response.body);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const b = new Blob([byteArray], {type: "application/pdf"});
          b.name = "test.pdf";
          this.currentPdf = URL.createObjectURL(b);
        } else {
          console.log(response);
        }
      }, (response) => {
        this.firstRequest = true;
        this.hideLoader();
        console.log(response);
      });
    },
    generate() {
      this.currentIndex = -1;
      for (let i = 0; i < this.selected.length; i++) {
        if (this.selected[i].finished === false) {
          this.currentIndex = i;
          break;
        }
      }
      if (this.currentIndex === -1) {
        this.hideLoader();
        return;
      }
      this.showLoader();
      let item = this.selected[this.currentIndex];
      let req = {};
      let isEinzel = false;

      if (!this.isKonto) {
        let task = item.task;
        let positions = item.data.positions;
        let taskEntries = [];
        let startDate = null;
        let endDate = null;
        for (let i = 0; i < positions.length; i++) {
          taskEntries.push(positions[i].id);
          if (startDate === null) {
            startDate = positions[i].dat_leist;
          } else {
            if (positions[i].dat_leist < startDate) {
              startDate = positions[i].dat_leist;
            }
          }
          if (endDate === null) {
            endDate = positions[i].dat_leist;
          } else {
            if (positions[i].dat_leist > endDate) {
              endDate = positions[i].dat_leist;
            }
          }
        }
        let templateNames = [];
        if (task.art_auf === "S" || task.art === "D") {
          templateNames.push(this.enzelSelect);
          isEinzel = true;
        } else {
          templateNames.push(this.sammelSelect);
        }
        console.log(task)
        let options = JSON.parse(JSON.stringify(task))
        // change the label
        let label = options.label;
        label = label.slice(options.pos_nr.length);
        label = options.key + " " + options.object + " -" + label;
        options.label = label;
        options.price = item.data.price_sum;
        options.invoice_type = this.isKonto ? "COLLECTION" : "TASK";

        req = {
          "data": [
            {
              "invoiceNumber": this.rnrPrefix + "/" + this.padded,
              "intakeAccount": task.hh_ein,
              "outtakeAccount": task.hh_aus,
              "billingPeriodStart": startDate,
              "billingPeriodEnd": endDate,
              "invoiceDate": new Date().toISOString(),
              "tasks": [
                {
                  "id": task.id,
                  "taskEntries": taskEntries
                }
              ]
            }
          ],
          "resultFileType": "Pdf",
          "templateNames": templateNames,
          "customerNumber": this.$cookies.get("ps_customer_number"),
          "aesKey": sessionStorage.getItem("aes"),
          "options": options
        }
      } else {
        let task = item.task;
        let aufMap = item.data.auf_map;
        let tasks = [];
        for (const [key, value] of Object.entries(aufMap)) {
          tasks.push({
            "id": key,
            "taskEntries": value
          });
        }
        let templateNames = [];
        if (task.art_auf === "S" || task.art === "D") {
          templateNames.push(this.enzelSelect);
        } else {
          templateNames.push(this.sammelSelect);
        }
        let options = JSON.parse(JSON.stringify(task))
        options.price = item.data.price_sum;
        options.invoice_type = this.isKonto ? "COLLECTION" : "TASK";
        let positions = item.data.positions;
        let startDate = null;
        let endDate = null;
        for (let i = 0; i < positions.length; i++) {
          if (startDate === null) {
            startDate = positions[i].dat_leist;
          } else {
            if (positions[i].dat_leist < startDate) {
              startDate = positions[i].dat_leist;
            }
          }
          if (endDate === null) {
            endDate = positions[i].dat_leist;
          } else {
            if (positions[i].dat_leist > endDate) {
              endDate = positions[i].dat_leist;
            }
          }
        }
        req = {
          "data": [
            {
              "invoiceNumber": this.rnrPrefix + "/" + this.padded,
              "intakeAccount": item.data.hh_ein,
              "outtakeAccount": item.data.hh_aus,
              "billingPeriodStart": startDate,
              "billingPeriodEnd": endDate,
              "invoiceDate": new Date().toISOString(),
              "tasks": tasks,
            }
          ],
          "resultFileType": "Pdf",
          "templateNames": templateNames,
          "customerNumber": this.$cookies.get("ps_customer_number"),
          "aesKey": sessionStorage.getItem("aes"),
          "options": options
        }
      }
      console.log(req)
      this.currentNumber +=1;
      this.$http.post(
          Server_URL+'/auftragsbuch/calculation/generate?is_einzel=' + (isEinzel ? "true" : "false"),
          req
      ).then((response) => {
        this.firstRequest = true;
        if (response.status === 200 ) {
          this.selected[this.currentIndex].finished = true;
          this.selected[this.currentIndex].rnr = response.body.rnr;
          const byteCharacters = atob(response.body.fileData);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const b = new Blob([byteArray], {type: "application/pdf"});
          b.name = this.rnrPrefix + "_" + this.padded + ".pdf";
          this.currentPdf = URL.createObjectURL(b);
          setTimeout(() => {
            window.frames["print_frame"].focus();
            if (this.modality === 'print') {
              window.frames["print_frame"].print();
              // wait till print dialog is closed
              const cleanup = () => {
                window.frames["print_frame"].removeEventListener('focus', cleanup);
                if (!this.combineInvoiceApiFiles) {
                  this.generateApiFile(this.selected[this.currentIndex].rnr, false);
                }
                this.generate();
              };
              // Add an event listener to detect when the window gains focus again
              window.frames["print_frame"].addEventListener('focus', cleanup);
            } else if (this.modality === 'save') {
              const a = document.createElement('a');
              a.href = this.currentPdf;
              a.download =  response.body.rnr.replace("/", "_") + ".pdf";
              a.style.position = 'fixed';
              a.target = '_blank';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              setTimeout(() => {
                if (!this.combineInvoiceApiFiles) {
                  this.generateApiFile(this.selected[this.currentIndex].rnr, false);
                }
                this.generate();
              }, 400)
            } else {
              setTimeout(() => {
                if (!this.combineInvoiceApiFiles) {
                  this.generateApiFile(this.selected[this.currentIndex].rnr, false);
                }
                this.generate();
              }, 400)
            }
          },500);
        } else {
          this.hideLoader();
          console.log(response);
        }
      }, (response) => {
        this.firstRequest = true;
        this.hideLoader();
        console.log(response);
      });
    }
  },
}
</script>

<style scoped>

 ::v-deep .modal-dialog {
  max-width: 100%;
  margin: 20px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: calc(100vh - 40px);
  display: flex;
  position: fixed;
  z-index: 100000;
}

 ::v-deep .modal-content {
  height: calc(100vh - 40px);
  border: none;
  border-radius: 4px;
 }

 ::v-deep .modal-body {
  height: 100%;
  padding: 0;
 }

 .form-control {
   color: black;
 }

</style>
